import React from 'react';

export default function PrimesInfoSection() {
  return (
    <div className="space-y-3">
      <div className="p-3 sm:p-4 bg-yellow-50 rounded-lg border border-yellow-200">
        <h4 className="font-semibold text-yellow-800 text-sm mb-1">
          ⚠️ Important
        </h4>
        <p className="text-xs sm:text-sm text-yellow-700">
          Ces montants sont indicatifs et peuvent varier selon votre établissement, 
          votre convention collective et votre organisation de travail. 
          Consultez votre service RH pour connaître les montants exacts.
        </p>
      </div>
    </div>
  );
}